import api from './axiosConfig';

// Call backend to fetch audit log entries, optionally filtered (e.g. by userEmail).
export const getAuditLogs = async (params = {}) => {
  try {
    const response = await api.get('/auditLogs', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching audit logs:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};
